import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./headerMenuItem.html";
class HeaderMenuItem extends LightningElement {
  constructor(...args) {
    super(...args);
    this.props = {};
  }
  onClick() {
    var _this$props$callbackF, _this$props;
    (_this$props$callbackF = (_this$props = this.props).callbackFunction) === null || _this$props$callbackF === void 0 ? void 0 : _this$props$callbackF.call(_this$props);
    this.dispatchEvent(new CustomEvent('toggle'));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(HeaderMenuItem, {
  publicProps: {
    props: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(HeaderMenuItem, {
  tmpl: _tmpl,
  sel: "appx-header-menu-item",
  apiVersion: 62
});
export default __lwc_component_class_internal;